import { matchPath } from 'react-router-dom';

import { ProfileData } from '../types/Profile';
import { AllowedProfiles } from '../utils/AllowedProfiles';
import { isEducationChildhoodProfile } from '../utils/isEducationChildhoodProfile';
import { RouteConfig } from './routesConfig';

type ProfileLike = Pick<
  ProfileData,
  'TeacherSegments' | 'segmentos' | 'perfil'
> | null;

export { isEducationChildhoodProfile };

export const getCurrentUserProfiles = (profile: ProfileLike): string[] => {
  const currentUserProfiles: string[] = [];
  const isStudent = AllowedProfiles(profile?.perfil?.nome, ['Aluno']);

  if (isStudent) {
    currentUserProfiles.push('student');
  }
  if (isEducationChildhoodProfile(profile)) {
    currentUserProfiles.push('education_childhood');
  }
  return currentUserProfiles;
};

export const findActiveGuardedRoute = (
  pathname: string,
  search: string,
  routes: RouteConfig[],
): RouteConfig | undefined => {
  const currentPath = pathname + search;

  const queryRoute = routes.find(
    route => route.path.includes('?') && route.path === currentPath,
  );
  if (queryRoute) {
    return queryRoute;
  }

  const pathRoutes = routes
    .filter(route => !route.path.includes('?') && route.blockedForProfiles?.length)
    .slice()
    .sort((a, b) => b.path.length - a.path.length);

  return pathRoutes.find(route =>
    matchPath({ path: route.path, end: true }, pathname),
  );
};

export const isRouteBlockedForProfiles = (
  route: RouteConfig | undefined,
  currentUserProfiles: string[],
): boolean =>
  !!route?.blockedForProfiles?.some(p => currentUserProfiles.includes(p));
